import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useLazyQuery } from "@apollo/client";

// queries
import { FETCH_PHOTO_UPLOAD_URLS } from "../../queries";

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

// components
import Image from "./Image";

const PhotoModLargeUploadImage = ({ uploadId, loadImage }) => {
    const [fetchImageUrl, { data, loading }] = useLazyQuery(
        FETCH_PHOTO_UPLOAD_URLS,
        {
            variables: {
                photoUploadIds: [uploadId]
            }
        }
    );

    useEffect(() => {
        if (loadImage) {
            fetchImageUrl();
        }
    }, [loadImage]);

    const url = data?.fetchPhotoUploadUrls?.items[0].uploadedImageUrl;
    const isLoading = loading || !url;

    return (
        <ImageWrapper>
            {!isLoading ? (
                <Image src={url} uploadId={uploadId} />
            ) : (
                <>loading image</>
            )}
        </ImageWrapper>
    );
};

export default PhotoModLargeUploadImage;

// prop-types
PhotoModLargeUploadImage.propTypes = {
    uploadId: PropTypes.string.isRequired,
    loadImage: PropTypes.bool
};
